import React from "react";
import moment from "moment";
import {
  CartesianGrid,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
  Scatter,
  Tooltip,
  XAxis,
  YAxis,
  ScatterChart,
  AreaChart,
  Area,
  ReferenceLine,
  ReferenceArea,
  Label,
} from "recharts";

// Memoized custom tick component for XAxis
const CustomXAxisTick = React.memo(({ x, y, payload }) => {
  // Format the time using moment.js
  const formattedTime = moment(payload.value).format("HH:mm Do");
  return (
    <text
      x={x}
      y={y}
      dy={8}
      textAnchor="middle"
      fill={"#f3f3f3"}
      fontSize={10}
      stroke={"#f3f3f3"}
      strokeWidth={0.5}
    >
      {formattedTime === "Invalid date" ? "" : formattedTime}
    </text>
  );
});

// Memoized custom tick component for YAxis
const CustomYAxisTick = React.memo(({ x, y, payload }) => {
  return (
    <text
      x={x}
      y={y}
      dy={-3}
      fill={"#f3f3f3"}
      textAnchor="middle"
      fontSize={10}
      stroke={"#f3f3f3"}
      strokeWidth={0.5}
    >
      {payload.value}
    </text>
  );
});

const CustomizedAreaChart = ({ data, dark }) => {
  return (
    <>
      <ResponsiveContainer
        className="mt-4 d-flex justify-content-center align-items-center"
        minHeight={300}
      >
        <AreaChart
          data={data}
          height="100%"
          width="100%"
          margin={{ bottom: 20 }}
        >
          <defs>
            <linearGradient id="pm2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="1%" stopColor="green" stopOpacity={0.3} />
              <stop offset="99%" stopColor="green" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="pm3" x1="0" y1="0" x2="0" y2="1">
              <stop offset="1%" stopColor="#FFC328" stopOpacity={0.3} />
              <stop offset="99%" stopColor="#FFC328" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="4 4" />
          <XAxis
            // tick={{
            //   stroke: dark ? "#f3f3f3" : "",
            //   fill: dark ? "#f3f3f3" : "#666",
            //   strokeWidth: 0.5,
            // }}
            // tickCount={7} // Set the approximate number of date/time ticks to display
            dataKey="enqueuedTime_Stamp"
            interval={data.length >500&&300}
            tick={<CustomXAxisTick />}
            tickFormatter={(unixTime) => {
              const formattedTime = moment(unixTime).format("HH:mm Do");
              return formattedTime === "Invalid date" ? "" : formattedTime;
            }}
            // tickFormatter={(unixTime) =>
            //   moment(unixTime).format("HH:mm Do") ===
            //   "Invalid date"
            //     ? ""
            //     : moment(unixTime).format("HH:mm Do")
            // }
            // tick={false}
            
          />
          <YAxis
            // tick={{
            //   stroke: dark ? "#f3f3f3" : "",
            //   fill: dark ? "#f3f3f3" : "#666",
            //   strokeWidth: 0.5,
            // }}
            // tick={false}
            tick={<CustomYAxisTick />}
            // unit='μ g/m ³'
          />
          <Tooltip
            labelFormatter={(value) => {
              return `label: ${moment(value).format("HH:mm Do")}`;
            }}
            wrapperClassName="navbar-bg"
          />
          <Legend
            verticalAlign="top"
            formatter={(value) => `${value} (μ g/m ³)`}
          />
          <Area
            type="monotone"
            dataKey="PM10"
            stroke="yellow"
            fillOpacity={1}
            fill="url(#pm2)"
            dot={false}
          />
          <Area
            type="monotone"
            dataKey="PM2.5"
            stroke="cyan"
            fillOpacity={1}
            fill="url(#pm3)"
            dot={false}
          />
          <ReferenceLine
            y={15}
            stroke="#FFC328"
            strokeWidth={2}
            label={
              <Label
                fontWeight="bold"
                value="15 µg/m3 or lower"
                fill={dark ? "white" : "black"}
              />
            }
          />
          <ReferenceLine
            y={50}
            stroke="green"
            strokeWidth={2}
            label={
              <Label
                fontWeight="bold"
                value="55 µg/m3 or lower"
                fill={dark ? "white" : "black"}
              />
            }
            dashboard-health-lead
          />
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
};

export default CustomizedAreaChart;
